import type { IPageAnalyticMapping } from '../../modules/analytic/types';

import { usePageAnalyticDetailContext } from '../../contexts/PageAnalyticDetailProvider';
import { PALineChartGroup } from '../../modules/analytic';
import { useAnalyticData } from '~/core/gemxql/hooks';
import { EMetricKey } from '~/types/metric';
import { useMemo } from 'react';

const ANALYTICS_DATA: IPageAnalyticMapping[] = [
  { key: EMetricKey.SESSION, title: 'Sessions' },
  { key: EMetricKey.VISITORS, title: 'Visitors' },
  { key: EMetricKey.BOUNCE_RATE, title: 'Bounce Rate' },
  { key: EMetricKey.CTR, title: 'Click-through rate' },
];
export const PageAnalyticOverview = () => {
  const { totalsRow, comparisonTotalsRow, columnTypes, isLoading } = usePageAnalyticDetailContext();
  const { computeMetric } = useAnalyticData();

  const analyticsData = useMemo(() => {
    return ANALYTICS_DATA.map(({ key, title }) => ({
      key,
      title,
      control: computeMetric({
        metric: totalsRow,
        previousMetric: comparisonTotalsRow,
        metricKey: key,
        formatter: columnTypes?.[key],
      }),
    }));
  }, [totalsRow, comparisonTotalsRow, columnTypes, computeMetric]);

  return (
    <PALineChartGroup
      defaultActiveTab={EMetricKey.SESSION}
      analyticsData={analyticsData}
      isLoading={isLoading}
    />
  );
};
